import React from 'react'

import { FeatureName } from './FeatureName'

export const FeatureContext = React.createContext<FeatureName[]>([])
